.progress {
  display: flex;
  gap: 4px;
}

.segment,
.segmentComplete {
  border-radius: 2px;
  flex: 1;
  height: 4px;
}

.segment {
  background: var(--colors-grays-light);
}

.segmentComplete {
  background: var(--colors-primary-main);
}

.next {
  @media (--reefer-media-tablet-max) {
    order: -1;
  }
}

@media (--reefer-media-tablet-min) {
  .lastStepSubmit {
      width: 50%;
  }
}
